/** A teacher's words in the person visit: the teaching profile, its sections and its removal. */
export const teachingCopy = {
  profileLabel: "Teaching profile",
  profileJob: "This person's public teaching facts, saved where each is drawn.",
  profileDetail: "Public teaching facts.",
  noTitle: "No title yet",
  title_role: "Title",
  specialization: "Specialization",
  training_chain: "Training chain",

  profileRemoved: "No teaching profile now",
  unknownSentence: "We could not confirm whether this was recorded. Check before trying again.",

  assignLabel: "Teaching assignments",
  assignJob: "The sections this person teaches.",
  noSections: "No sections assigned yet",
  everyTerm: "Across every term.",
  selectedTerm: "In the selected term.",
  noTerm: "No term",
  primary: "Primary",
  coInstructor: "Co-instructor",
  openSection: "Open section",

  removeLabel: "Remove teaching profile",
  removeJob: "Remove an unused teaching profile.",
  removeDetail: "Teaching history is kept. Use Archive person to remove someone from working lists.",
  removeVerb: "Remove profile",
  removeCap: "When you remove",
  removeEffect: "Remove the teaching profile; sign-in and access stay",
  referPart: "Courses that refer to it",
  noneRefer: "None",
  noneReferSummary: "No course refers to this profile.",
  checkingCourses: "Checking every course assignment.",
  previewUnavailable: "Couldn't check the courses",
  previewUnavailableDetail: "Nothing is removed while the courses are unread.",
  profileKept: "Profile kept",
  removed: "Removed",
  returnRereads: "Return reads People again",
  removeRefused: "Not removed.",
  removeUnknown: "Removing the teaching profile",
  removeCheckNote: "Reads the teaching profile. Nothing is removed again.",
} as const;

const plural = (count: number, one: string, many: string) => `${count} ${count === 1 ? one : many}`;

export const teachingText = {
  crn: (crn: string) => `CRN ${crn}`,
  sections: (count: number) => plural(count, "section", "sections"),
  mayTeach: (name: string) => `${name.trim().split(/\s+/)[0] || "This person"} may teach but has no profile.`,
  refer: (count: number) => `${plural(count, "course refers", "courses refer")} to it`,
  clearFirst: (count: number) => `Keep this profile for ${plural(count, "course", "courses")}. Use Archive person to remove them from working lists.`,
};
